module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "text-center": "",
      "d-flex": "",
      "align-center": ""
    }
  }, [_c('c-confirm-dialog', {
    attrs: {
      "titulo": "Deseja realmente excluir o órgão financiador?"
    },
    on: {
      "yes": function($event) {
        return _vm.excluirOrgaoFinanciadorProjetoPesquisa()
      }
    },
    model: {
      value: (_vm.dialogConfirmaExclusao),
      callback: function($$v) {
        _vm.dialogConfirmaExclusao = $$v
      },
      expression: "dialogConfirmaExclusao"
    }
  }), _vm._v(" "), _c('v-data-table', {
    attrs: {
      "headers": _vm.headers,
      "items": _vm.listaOrgaosFinanciadores,
      "search": _vm.search,
      "no-data-text": 'Nenhum órgão financiador cadastrado.',
      "must-sort": "",
      "sort-by": _vm.sortBy,
      "sort-desc": _vm.sortDesc,
      "items-per-page": _vm.itemsPerPage,
      "footer-props": {
        itemsPerPageText: 'Linhas por página',
        itemsPerPageOptions: _vm.opcoesPaginacao
      }
    },
    on: {
      "update:sortBy": function($event) {
        _vm.sortBy = $event
      },
      "update:sort-by": function($event) {
        _vm.sortBy = $event
      },
      "update:sortDesc": function($event) {
        _vm.sortDesc = $event
      },
      "update:sort-desc": function($event) {
        _vm.sortDesc = $event
      }
    },
    scopedSlots: _vm._u([{
      key: "item.opcoes",
      fn: function(props) {
        return [_c('div', [(_vm.administradorPRPPG || _vm.projetoPesquisa.coordenador) ? _c('c-tooltip-btn', {
          attrs: {
            "icon": "edit",
            "color": "primary",
            "tooltip": "Editar órgão financiador"
          },
          on: {
            "click": function($event) {
              return _vm.toEditarOrgaoFinanciadorProjetoPesquisa(props.item.id)
            }
          }
        }) : _vm._e(), _vm._v(" "), (_vm.administradorPRPPG || _vm.projetoPesquisa.coordenador) ? _c('c-tooltip-btn', {
          attrs: {
            "icon": "delete",
            "color": "primary",
            "tooltip": "Excluir órgão financiador"
          },
          on: {
            "click": function($event) {
              return _vm.toExcluirOrgaoFinanciadorProjetoPesquisa(props.item.id)
            }
          }
        }) : _vm._e()], 1)]
      }
    }, {
      key: "item.sigla",
      fn: function(props) {
        return [_vm._v(_vm._s(props.item.sigla === null || props.item.sigla === '' ? '-' : props.item.sigla))]
      }
    }, {
      key: "item.valor",
      fn: function(props) {
        return [_vm._v(_vm._s(props.item.valor.toLocaleString('pt-br', {
          style: 'currency',
          currency: 'BRL'
        })))]
      }
    }, {
      key: "footer.page-text",
      fn: function(ref) {
        var pageStart = ref.pageStart;
        var pageStop = ref.pageStop;

        return [_vm._v("\n      Mostrando " + _vm._s(pageStart) + " a " + _vm._s(pageStop) + " de " + _vm._s(_vm.listaOrgaosFinanciadores.length) + " " + _vm._s(_vm.listaOrgaosFinanciadores.length > 1 ? 'órgãos financiadores' : 'órgão financiador') + "\n    ")]
      }
    }])
  }), _vm._v(" "), _c('br'), _c('br'), _vm._v(" "), _c('v-card-actions', [_c('v-btn', {
    attrs: {
      "color": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.toVoltar()
      }
    }
  }, [_vm._v("Voltar")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), (_vm.administradorPRPPG || _vm.projetoPesquisa.coordenador) ? _c('v-btn', {
    attrs: {
      "color": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.toPesquisarOrgao()
      }
    }
  }, [_vm._v("Adicionar Órgão Financiador")]) : _vm._e(), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.toAvancar()
      }
    }
  }, [_vm._v("Avançar")])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-cf657c52","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/pesquisa/orgaos-financiadores.vue
// module id = 850
// module chunks = 0